<template>
  <!--
    Decorative gold-coin icon (Figma node 18681:46656). The gradient/filter
    element ids are made unique PER INSTANCE with `useId()` so mounting the coin
    more than once in a document never collides — SVG `url(#id)` references
    resolve to the FIRST matching id in the document, so shared hardcoded ids
    would silently steal each other's gradient/filter.
  -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 30 30"
    fill="none"
    aria-hidden="true"
  >
    <g :filter="`url(#${filterId})`">
      <circle cx="15" cy="15" r="15" :fill="`url(#${gradId})`" />
    </g>
    <circle cx="15" cy="15" r="14.5" :stroke="`url(#${strokeId})`" />
    <defs>
      <filter
        :id="filterId"
        x="0"
        y="0"
        width="30"
        height="32"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
      </filter>
      <linearGradient
        :id="gradId"
        x1="30"
        y1="0"
        x2="0"
        y2="30"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFCA17" />
        <stop offset="1" stop-color="#977400" />
      </linearGradient>
      <linearGradient
        :id="strokeId"
        x1="30"
        y1="0"
        x2="0"
        y2="30"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EFEDDB" />
        <stop offset="1" stop-color="#AB8F54" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup lang="ts">
import { useId } from "vue";

// One base id per component instance; deriving the three element ids from it
// keeps them grouped and collision-free across every mounted coin.
const uid = useId();
const filterId = `coin-filter-${uid}`;
const gradId = `coin-grad-${uid}`;
const strokeId = `coin-stroke-${uid}`;
</script>
